export function resolveOauth() {
  return window['OAUTH_CONFIG'];
}

export function resolveApplicationInsights() {
  return window['ENVIRONMENT'].applicationInsights;
}
